(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["facturacion-atomico"] && !Shopify.designMode) return;
  try {
    
/* Normaliza el RFC real enviado, además de mostrarlo en mayúsculas.
   La comprobación de formato no valida su registro ante el SAT. */
document.addEventListener('input', (event) => {
  if (event.target.matches('.atomico-invoice [data-invoice-rfc]')) {
    const field = event.target;
    const start = field.selectionStart;
    const end = field.selectionEnd;
    field.value = field.value.toUpperCase();
    if (start !== null && end !== null) field.setSelectionRange(start, end);
  }
});

/* Muestra usos compatibles con el régimen seleccionado.
   CP01 y CN01 permanecen deshabilitados: son para pagos y nómina.
   Si cambia el régimen, borra un uso que ya no sea compatible. */
function atomicoUpdateInvoiceUses(form) {
  const regimen = form.querySelector('[data-invoice-regimen]');
  const uso = form.querySelector('[data-invoice-uso]');
  if (!regimen || !uso) return;
  const code = regimen.selectedOptions[0]?.dataset.code || '';
  const oldValue = uso.value;
  for (const option of uso.options) {
    if (!option.value) continue;
    const compatible = !code || option.dataset.regimes.split(',').includes(code);
    option.hidden = !compatible;
    option.disabled = !compatible || option.dataset.special === 'true';
  }
  const selected = [...uso.options].find(option => option.value === oldValue);
  if (!code || (selected && selected.disabled)) uso.value = '';
  uso.disabled = !code;
}
function atomicoInitInvoiceMenus(root) {
  root.querySelectorAll('.atomico-invoice form').forEach(atomicoUpdateInvoiceUses);
}
document.addEventListener('change', (event) => {
  if (event.target.matches('.atomico-invoice [data-invoice-regimen]')) {
    atomicoUpdateInvoiceUses(event.target.form);
  }
});
document.addEventListener('shopify:section:load', (event) => {
  atomicoInitInvoiceMenus(event.target);
});
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => atomicoInitInvoiceMenus(document), { once: true });
} else {
  atomicoInitInvoiceMenus(document);
}


/* Conserva un solo # al inicio y permite números, letras y espacios. */
function atomicoOrderValue(value) {
  return '#' + value.replace(/#/g, '').replace(/[\r\n]/g, ' ');
}
/* Limpia importes; admite punto decimal y hasta dos decimales.
   Al pegar $1,899.99 elimina la coma de miles.
   También acepta 1899,99 como importe decimal. */
function atomicoMoneyValue(value, complete) {
  if (value.includes('-')) return '$';
  let amount = value.replace(/[^0-9.,]/g, '');
  if (!amount.includes('.') && /^[0-9]+,[0-9]{1,2}$/.test(amount)) {
    amount = amount.replace(',', '.');
  } else {
    amount = amount.replace(/,/g, '');
  }
  const parts = amount.split('.');
  let integer = parts[0].replace(/^0+(?=[0-9])/, '');
  let decimals = parts.slice(1).join('').slice(0, 2);
  if (!integer && parts.length > 1) integer = '0';
  if (!integer) return '$';
  if (complete) return '$' + integer + '.' + decimals.padEnd(2, '0');
  return '$' + integer + (parts.length > 1 ? '.' + decimals : '');
}
function atomicoFormatInvoiceField(field, complete = false) {
  const money = field.matches('[data-invoice-money]');
  const start = field.selectionStart;
  const before = start === null ? field.value : field.value.slice(0, start);
  field.value = money
    ? atomicoMoneyValue(field.value, complete)
    : atomicoOrderValue(field.value);
  if (money) {
    const nonZero = /[1-9]/.test(field.value);
    field.setCustomValidity(field.value === '$' || nonZero ? '' : 'Escribe un importe mayor que $0.00.');
  }
  if (!complete && start !== null) {
    const cleanedBefore = money ? atomicoMoneyValue(before, false) : atomicoOrderValue(before);
    const caret = Math.min(field.value.length, Math.max(1, cleanedBefore.length));
    field.setSelectionRange(caret, caret);
  }
}
document.addEventListener('input', (event) => {
  if (event.target.matches('.atomico-invoice [data-invoice-order], .atomico-invoice [data-invoice-money]')) {
    atomicoFormatInvoiceField(event.target);
  }
});
/* Añade .00 al salir del importe; mantiene el prefijo al borrar. */
document.addEventListener('focusout', (event) => {
  if (event.target.matches('.atomico-invoice [data-invoice-money]')) {
    atomicoFormatInvoiceField(event.target, true);
  }
});
document.addEventListener('keydown', (event) => {
  const field = event.target;
  if (!field.matches('.atomico-invoice [data-invoice-order], .atomico-invoice [data-invoice-money]')) return;
  if (event.key === 'Backspace' && field.selectionStart <= 1 && field.selectionEnd <= 1) event.preventDefault();
});
/* Asegura el formato enviado, incluso si no se salió del campo. */
document.addEventListener('submit', (event) => {
  if (!event.target.matches('.atomico-invoice form')) return;
  event.target.querySelectorAll('[data-invoice-order], [data-invoice-money]').forEach(field => {
    atomicoFormatInvoiceField(field, field.matches('[data-invoice-money]'));
  });
  if (!event.target.reportValidity()) event.preventDefault();
}, true);
function atomicoInitInvoicePrefixes(root) {
  root.querySelectorAll('.atomico-invoice [data-invoice-order], .atomico-invoice [data-invoice-money]').forEach(field => {
    atomicoFormatInvoiceField(field, field.matches('[data-invoice-money]') && field.value !== '$');
  });
}
document.addEventListener('shopify:section:load', event => atomicoInitInvoicePrefixes(event.target));
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => atomicoInitInvoicePrefixes(document), { once: true });
} else {
  atomicoInitInvoicePrefixes(document);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lote-sorpresa"] && !Shopify.designMode) return;
  try {
    

function abrirDescripcionLote(root) {
  if (root.dataset.descripcionInicializada) return;
  root.dataset.descripcionInicializada = '1';

  const observer = new MutationObserver(abrir);

  function abrir() {
    const tab = root.querySelector(
      '.station-tabs-tab[data-slug="descripcion"]'
    );

    if (!tab) return false;
    observer.disconnect();

    setTimeout(() => {
      if (
        tab.isConnected &&
        tab.getAttribute('aria-expanded') === 'false'
      ) {
        tab.click();
      }
    }, 200);

    return true;
  }

  if (!abrir()) {
    observer.observe(root, {
      childList: true,
      subtree: true
    });

    setTimeout(() => observer.disconnect(), 15000);
  }
}

document.querySelectorAll('.lote-sorpresa')
  .forEach(abrirDescripcionLote);

document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('.lote-sorpresa')
    .forEach(abrirDescripcionLote);
});
function initLote(root){
 if(root.dataset.ready)return;root.dataset.ready='1';
 const cfg=JSON.parse(root.querySelector('.lote-config').textContent),form=root.querySelector('form'),lot=root.querySelector('.lote-count'),rows=root.querySelector('.lote-rows'),button=root.querySelector('.lote-add');
 const choices=Array.from({length:20},()=>({cut:'',size:''}));
 const money=n=>'$'+new Intl.NumberFormat('es-MX',{minimumFractionDigits:2,maximumFractionDigits:2}).format(n/100)+' '+(cfg.currency||'MXN');
 function update(){
  const n=Number(lot.value),xxl=choices.slice(0,n).filter(c=>c.cut==='CABALLERO'&&c.size==='XXL').length;
  const variant=cfg.variants.find(v=>v.option1===n+' playeras'&&v.option2===String(xxl));
  root.querySelector('.lote-variant').value=variant?variant.id:'';
  button.disabled=!variant||!variant.available;
  root.querySelector('.lote-price').textContent=variant?money(variant.price):cfg.labels.unavailable;
  const summary=root.querySelector('.lote-summary');summary.replaceChildren();
  for(const [label,value,cls] of [[cfg.labels.extra+' ('+xxl+')',money(xxl*4900),'lote-extra-line'],[cfg.labels.total,variant?money(variant.price):'—','lote-total-line']]){const line=document.createElement('div');line.className=cls;const title=document.createElement('span');title.textContent=label+': ';const amount=document.createElement('strong');amount.textContent=value;line.append(title,amount);summary.append(line);}
 }
 function render(){
  rows.replaceChildren();
  for(let i=0;i<Number(lot.value);i++){
   const row=document.createElement('div');row.className='lote-row';
   const number=document.createElement('span');number.textContent=i+1;row.append(number);
   const makeSelect=(label,cls)=>{
    const wrap=document.createElement('label');
    const select=document.createElement('select');select.className=cls;select.required=true;
    select.setAttribute('aria-label',label+' '+(i+1));wrap.append(select);row.append(wrap);return select;
   };
   const cut=makeSelect(cfg.labels.cut,'lote-cut'),size=makeSelect(cfg.labels.size,'lote-size');
   function options(select,values,label){select.replaceChildren(new Option(label,''),...values.map(v=>new Option(v,v)));}
   options(cut,['CABALLERO','DAMA','NIÑO'],cfg.labels.cut);cut.value=choices[i].cut;
   const prop=document.createElement('input');prop.type='hidden';prop.name='properties['+cfg.labels.shirt+' '+String(i+1).padStart(2,'0')+']';row.append(prop);
   function sizes(){if(cut.value!=='CABALLERO'&&choices[i].size==='XXL')choices[i].size='';options(size,['CH','M','L','XL',...(cut.value==='CABALLERO'?['XXL']:[])],cfg.labels.size);size.value=choices[i].size;}
   function property(){prop.value=cut.value+' · '+size.value;}
   sizes();property();
   cut.addEventListener('change',()=>{choices[i].cut=cut.value;sizes();property();update();});
   size.addEventListener('change',()=>{choices[i].size=size.value;property();update();});
   rows.append(row);
  }
  update();
 }
 lot.addEventListener('change',render);
 form.addEventListener('submit',event=>{update();if(!form.reportValidity()||button.disabled)event.preventDefault();});
 render();
}
document.querySelectorAll('.lote-sorpresa').forEach(initLote);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.lote-sorpresa').forEach(initLote));

  } catch(e) { console.error(e); }
})();
})();
